
define('C25.Banner.View'
	, [
		'CustomContentType.Base.View'

		, 'c25_banner.tpl'

		, 'jQuery'
		, 'underscore'

		, 'Tools'
	]
	, function (
		CustomContentTypeBaseView

		, c25_banner_tpl

		, jQuery
		, _

		, Tools
	) {
		'use strict';

		return CustomContentTypeBaseView.extend({

			template: c25_banner_tpl
			,
			initialize: function () {

			}
			, getContext: function getContext() {
				if (this.settings.custrecord_cct_banner_content) {
					this.settings.custrecord_cct_banner_content = this.settings.custrecord_cct_banner_content.split("target=\"_blank\"").join(" ");
				}
				if (this.settings.custrecord_cct_banner_title) {
					this.settings.custrecord_cct_banner_title = this.settings.custrecord_cct_banner_title.split("&lt;").join("<");
					this.settings.custrecord_cct_banner_title = this.settings.custrecord_cct_banner_title.split("&gt;").join(">");
				}

				//console.log("settings", this.settings);

				return this.settings;
			}
		});
	});
